import { Auth0Error } from 'auth0-js';
import { ILoginData } from 'Auth';
// eslint-disable-next-line import/no-cycle
import { RequestError } from 'Api';
import { BaseFormModel } from './BaseFormModel';
import { BaseAuthFormModelSender } from './BaseAuthFormModelSender';
import { BaseAuthFormModelErrorHandler } from './BaseAuthFormModelErrorHandler';

export abstract class BaseAuthFormModel extends BaseFormModel<ILoginData> {
  authFormSender: BaseAuthFormModelSender;
  formErrorHandler: BaseAuthFormModelErrorHandler;

  constructor() {
    super();

    this.authFormSender = new BaseAuthFormModelSender();
    this.formErrorHandler = new BaseAuthFormModelErrorHandler();
  }

  // Array of fields names from model to form data as array of values from model data and pass as arguments to auth method
  abstract get sendArguments(): [string, string];
  // Name of method to call on auth service
  abstract get authMethod(): 'login';

  geAuthSendData() {
    const sendData: string[] = [];
    this.sendArguments.forEach((fieldName: string) => {
      sendData.push(String(this.fieldsData[fieldName]));
    });
    return sendData;
  }

  get sendUrl() {
    return '';
  }

  async send() {
    try {
      const sendData = this.geAuthSendData();
      return await this.authFormSender.send(this.authMethod, sendData);
    } catch (error) {
      throw this.formErrorHandler.getNormalizedError(error as RequestError & Auth0Error);
    }
  }
}
